import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  CREATE_STATISTIC_REQUEST: '',
  CREATE_STATISTIC_SUCCESS: '',
  CREATE_STATISTIC_FAILURE: '',

  GET_IPA_BY_USER_REQUEST: '',
  GET_IPA_BY_USER_SUCCESS: '',
  GET_IPA_BY_USER_FAILURE: '',

  GET_VENDORS_REQUEST: '',
  GET_VENDORS_SUCCESS: '',
  GET_VENDORS_FAILURE: '',

  REPORT_ISSUE_REQUEST: '',
  REPORT_ISSUE_SUCCESS: '',
  REPORT_ISSUE_FAILURE: '',

  GET_CONTACTS_REQUEST: '',
  GET_CONTACTS_SUCCESS: '',
  GET_CONTACTS_FAILURE: '',

  GET_COMPANIES_INFO_REQUEST: '',
  GET_COMPANIES_INFO_SUCCESS: '',
  GET_COMPANIES_INFO_FAILURE: '',

  GET_DOWNLOADABLE_FORMS_REQUEST: '',
  GET_DOWNLOADABLE_FORMS_SUCCESS: '',
  GET_DOWNLOADABLE_FORMS_FAILURE: '',

  GET_DOWNLOADABLE_RESOURCES_REQUEST: '',
  GET_DOWNLOADABLE_RESOURCES_SUCCESS: '',
  GET_DOWNLOADABLE_RESOURCES_FAILURE: '',

  GET_DOWNLOAD_FILE_REQUEST: '',
  GET_DOWNLOAD_FILE_SUCCESS: '',
  GET_DOWNLOAD_FILE_FAILURE: '',

  GET_DOWNLOAD_RESOURCES_REQUEST: '',
  GET_DOWNLOAD_RESOURCES_SUCCESS: '',
  GET_DOWNLOAD_RESOURCES_FAILURE: '',

  GET_LOGO_REQUEST: '',
  GET_LOGO_SUCCESS: '',
  GET_LOGO_FAILURE: '',

  GET_USER_ACK_REQUEST: '',
  GET_USER_ACK_SUCCESS: '',
  GET_USER_ACK_FAILURE: '',

  CREATE_USER_ACK_REQUEST: '',
  CREATE_USER_ACK_SUCCESS: '',
  CREATE_USER_ACK_FAILURE: '',

  CREATE_FAX_OUT_REQUEST: '',
  CREATE_FAX_OUT_SUCCESS: '',
  CREATE_FAX_OUT_FAILURE: '',

  GET_FAX_OUT_REQUEST: '',
  GET_FAX_OUT_SUCCESS: '',
  GET_FAX_OUT_FAILURE: '',

  CREATE_FAX_OUT_REPORT_REQUEST: '',
  CREATE_FAX_OUT_REPORT_SUCCESS: '',
  CREATE_FAX_OUT_REPORT_FAILURE: '',

  SEND_USER_FEEDBACK_REQUEST: '',
  SEND_USER_FEEDBACK_SUCCESS: '',
  SEND_USER_FEEDBACK_FAILURE: '',

  GET_MEASURE_REPORT_PRINT_FILE_REQUEST: '',
  GET_MEASURE_REPORT_PRINT_FILE_SUCCESS: '',
  GET_MEASURE_REPORT_PRINT_FILE_FAILURE: '',

  SHOW_WEB_PILOT_POSTING: '',
  UPDATE_SHOW_WEB_PILOT_POSTING: '',
  UPDATE_FAX_OPT_OUT_PROVIDERS: '',
  UPDATE_COMPANY_NAMES: '',
  UPDATE_VENDOR_NAMES: '',

  GET_ATTESTATION_POPUP_CONTENT_REQUEST: '',
  GET_ATTESTATION_POPUP_CONTENT_SUCCESS: '',
  GET_ATTESTATION_POPUP_CONTENT_FAILURE: '',

  CHECK_ATTESTATION_VISIBILITY_REQUEST: '',
  CHECK_ATTESTATION_VISIBILITY_SUCCESS: '',
  CHECK_ATTESTATION_VISIBILITY_FAILURE: '',

  ADD_ATTESTATION_REQUEST: '',
  ADD_ATTESTATION_SUCCESS: '',
  ADD_ATTESTATION_FAILURE: '',

  DOWNLOAD_ATTESTATION_REQUEST: '',
  DOWNLOAD_ATTESTATION_SUCCESS: '',
  DOWNLOAD_ATTESTATION_FAILURE: '',

  GET_ALL_ATTESTED_TIMESTAMP_REQUEST: '',
  GET_ALL_ATTESTED_TIMESTAMP_SUCCESS: '',
  GET_ALL_ATTESTED_TIMESTAMP_FAILURE: ''


};

types = setStoreTypeValues(types, 'app');

export default types;
